import * as types from './mutations-types';

export const mutations = {
  [types.SET_TABLES](state, tables) {
    state.customizedTables = { tables: tables };
  },
  [types.CLEAR_TABLES](state) {
    state.customizedTables = { tables: [] };
  },
};
